import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import { IMemberTestosteroneGoalsPageContent } from '@ui/routes/MemberTestosterone/MemberTestosteroneGoalsStep/MemberTestosteroneGoalsStep.component';
import { MemberTestosteroneGoalsStep } from '@ui/routes/MemberTestosterone/MemberTestosteroneGoalsStep/index';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

export interface MemberTestosteroneGoalsStepProps extends IFlowStepProps {}

const MemberTestosteroneGoalsStepPage: FC<MemberTestosteroneGoalsStepProps> = ({
	path,
	stepKey,
}) => {
	const { existingFormData, handleFormSubmission, handleNavBack } = useContext(FlowContext);

	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-testosterone-hrt-goals" }) {
				page_header
				page_info
				hrt_goals_emotional_benefits
				hrt_goals_gender_euphoria
				hrt_goals_deepen_voice
				hrt_goals_improve_libido
				hrt_goals_bottom_growth
				hrt_goals_redistribute_fat
				hrt_goals_muscle_strength
				hrt_goals_chest_change
				hrt_goals_body_hair
				hrt_goals_facial_hair
				hrt_goals_other
			}
		}
	`);

	const refinedContent: IMemberTestosteroneGoalsPageContent = keysToCamel(
		pageContent
	) as IMemberTestosteroneGoalsPageContent;

	return (
		<MemberTestosteroneGoalsStep
			pageContent={refinedContent}
			path={path}
			stepKey={stepKey}
			existingFormData={existingFormData}
			handleFormSubmission={handleFormSubmission}
			handleNavBack={handleNavBack}
		/>
	);
};

export default MemberTestosteroneGoalsStepPage;
